module.exports = __webpack_public_path__ + "static/media/star.24388236.svg";